define([
    'text!WebCommon/component/num-input-group.html',
    'lodash',

    'css!WebCommon/component/num-input-group.css'
], function(
    tpl,
    _
){
    return {
        template: tpl,
        props: {
            value: {
                type: Number,
                default: 1
            },
            min: {
                type: Number,
                default: 1
            }
        },
        data: function(){
            return {
                num: this.value
            };
        },
        watch: {
            value: 'updateNum',
            num: 'debounceUpdateNum'
        },
        methods: {
            updateNum: function(n){
                var num = parseInt(n || this.num);
                if (_.isNaN(num) || num < this.min){
                    this.num = this.min;
                } else {
                    this.num = num;
                }
                this.$emit('input', this.num);
            },
            debounceUpdateNum: _.debounce(function(n){
                this.updateNum(n);
            }, 1000),
            calc: function(num){
                this.num += num;
                this.updateNum();
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/component/num-input-group.js
// module id = 111
// module chunks = 0